/* eslint-disable */
export default {
  title: 'Región',
  NAOnlyMessage:
    'Defina su código de área. Se utilizará para la marcación local.',
  MultiWithNAMessage:
    'Defina el país y el prefijo de su región. Se utilizará para la marcación local y el formato de número de teléfono.',
  MultiWithoutNAMessage:
    'Seleccioné el país en el que se encuentra. Esto se utilizará para la marcación local y el formato de número de teléfono.',
  country: 'País',
  areaCode: 'Código de área',
  areaCodePlaceholder: 'Introducir código de área',
} as const;

// @key: @#@"title"@#@ @source: @#@"Region"@#@
// @key: @#@"NAOnlyMessage"@#@ @source: @#@"Please set your area code. This will be used for local dialing."@#@
// @key: @#@"MultiWithNAMessage"@#@ @source: @#@"Please set the country and area code for your region. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"MultiWithoutNAMessage"@#@ @source: @#@"Please select the country you locate in. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"country"@#@ @source: @#@"Country"@#@
// @key: @#@"areaCode"@#@ @source: @#@"Area Code"@#@
// @key: @#@"areaCodePlaceholder"@#@ @source: @#@"Enter Area Code"@#@
